/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Marcus Biesel <m.biesel@techdivision.com>
 */

import React from 'react';
import { Field, useField, useFormikContext } from 'formik';
import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { useIbanValidator } from '../../Checkout/FormModel/useIbanValidator';

/**
 * IbanFieldMui Component
 * @param props
 * @returns {Element}
 * @constructor
 */
function IbanFieldMui(props) {
  const { errorText, validateField, ...rest } = props;
  const [field, meta] = useField(props);
  const { handleBlur } = useFormikContext();

  const { validateIban } = useIbanValidator(validateField);

  function _renderHelperText() {
    const { touched, error } = meta;
    if (touched && error) {
      return error;
    }
    return null;
  }

  return (
    <TextField
      {...field}
      {...rest}
      type="text"
      error={meta.touched && meta.error && true}
      helperText={_renderHelperText()}
      onBlur={(event) => {
        handleBlur(event);
        if (field.value.length > 0) {
          validateIban(event);
        }
      }}
    />
  );
}

export default function IbanField(props) {
  return (
    <Field
      {...props}
      as={IbanFieldMui}
    />
  );
}

IbanFieldMui.propTypes = {
  errorText: PropTypes.string,
  validateField: PropTypes.func.isRequired,
};

IbanFieldMui.defaultProps = {
  errorText: '',
};
